import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Search, User } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SAMIDEL_LOGO = "https://customer-assets.emergentagent.com/job_fabriflow/artifacts/vi8gu83e_logo-hero-samidel.png";

/**
 * Selecao rapida de operador para tarefas pontuais (sem teclado numerico)
 * Aparece quando o operador escaneia o QR Code sem estar autenticado
 */
export default function SelecionarOperadorPontuais() {
  const [operadores, setOperadores] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadOperadores = async () => {
      try {
        const res = await axios.get(`${API}/operadores?perfil=operador`);
        setOperadores((res.data || []).filter(op => op.ativo !== false));
      } catch (e) {
        console.error('Erro ao carregar operadores:', e);
      } finally {
        setLoading(false);
      }
    };
    loadOperadores();
  }, []);

  const filtrados = search.trim()
    ? operadores.filter(op =>
        (op.nome_completo || '').toLowerCase().includes(search.toLowerCase()) ||
        (op.username || '').toLowerCase().includes(search.toLowerCase())
      )
    : operadores;

  const handleSelect = (op) => {
    navigate(`/sim/operador/${op.username}?tab=pontuais`);
  };

  return (
    <div className="min-h-screen bg-stone-50 flex flex-col items-center px-4 py-8">
      {/* Logo */}
      <img src={SAMIDEL_LOGO} alt="Samidel" className="h-14 mb-6" />

      <h1 className="text-xl font-bold text-stone-800 mb-1">Tarefas Pontuais</h1>
      <p className="text-sm text-stone-500 mb-6">Selecione o seu nome para continuar</p>

      {/* Pesquisa */}
      <div className="relative w-full max-w-sm mb-4">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Procurar operador..."
          className="w-full pl-10 pr-4 py-3 rounded-xl border border-stone-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-primary/30"
          autoFocus
          data-testid="search-operador-pontuais"
        />
      </div>

      {/* Lista de operadores */}
      <div className="w-full max-w-sm space-y-2 overflow-y-auto" style={{ maxHeight: '60vh' }}>
        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-3 border-primary border-t-transparent mx-auto"></div>
          </div>
        ) : filtrados.length === 0 ? (
          <p className="text-center text-stone-400 py-8">Nenhum operador encontrado</p>
        ) : (
          filtrados.map(op => (
            <button
              key={op.id}
              onClick={() => handleSelect(op)}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-white border border-stone-200 hover:border-primary hover:bg-primary/5 transition-all text-left active:scale-[0.98]"
              data-testid={`select-operador-${op.username}`}
            >
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <User className="h-5 w-5 text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-stone-800 truncate">{op.nome_completo || op.username}</p>
                <p className="text-xs text-stone-400">{op.username}</p>
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
}
